<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-form @submit.prevent="register">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t("registrarse") }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                :label="$t('correo_electronico')"
                prepend-icon="mdi-at"
                type="email"
                v-model="email"
                autocomplete="off"
                required
                autofocus
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" :disabled="btnDisabled" color="primary">{{
                $t("enviar")
              }}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      btnDisabled: false,
    };
  },
  methods: {
    async register() {
      this.openLoader();
      const registerURL = `${this.$store.state.proveedorUrl}register`;
      const registerParams = { email: this.email };
      const registerRequest = await this.sendRequest(
        registerURL,
        registerParams,
        "POST"
      );
      if (registerRequest.success) {
        this.showSuccessMessage(registerRequest.message);
        this.btnDisabled = true;
      }
      this.closeLoader();
    },
  },
};
</script>